import {
  createFieldTransport,
  type EnsureFreshOutcome,
  type TransportAdapter,
} from "@njbsoft/field-sync";
import { fieldApiClient, refreshManager } from "@/lib/auth";

// The engine's run preamble is refresh-before-drain: a queued regulatory write
// must never race an expired bearer. RefreshOutcome and EnsureFreshOutcome are
// the same three-way distinction under two names — the session layer calls the
// success arm "refreshed", the engine calls it "fresh" — so the map is one
// rename, not a reclassification.
async function ensureFresh(): Promise<EnsureFreshOutcome> {
  const { outcome } = await refreshManager.refreshOutcome();
  return { outcome: outcome === "refreshed" ? "fresh" : outcome };
}

/**
 * The field-stack transport for the sync engine, bound to the portal's one
 * field client — every engine wire call therefore shares the RefreshManager
 * 401 dedup with the interactive tester hooks.
 */
export function createCompanyFieldTransport(): TransportAdapter {
  return createFieldTransport({ client: fieldApiClient, ensureFresh });
}
